import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Kelp extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene, type, opac, animate) {
    super(scene);

    this.type = type;
    this.opac = opac;
    this.initAnim = animate;

    this.contTop4 = null;
    this.contTop3 = null;
    this.contTop2 = null;
    this.contTop1 = null;

    /** @type {Phaser.Tweens.Tween[]} */
    this.kelpTweens = [];

    this.setup();
  }

  setup () {
    this.contTop4 = this.scene.add.container();
    this.contTop3 = this.scene.add.container();
    this.contTop2 = this.scene.add.container();
    this.contTop1 = this.scene.add.container();

    this.contTop2.add(this.contTop1);
    this.contTop3.add(this.contTop2);
    this.contTop4.add(this.contTop3);
    this.add(this.contTop4);

    this.createStalk();

    this.alpha = this.opac;
  }

  createStalk () {
    const kelp1 = ABCyaPhaser.Images.addImage(0,0, `5_Level 2/Lvl2_Kelp${this.type}_1`, this.contTop1).setOrigin(0.3, 1);
    const kelp2 = ABCyaPhaser.Images.addImage(0,0, `5_Level 2/Lvl2_Kelp${this.type}_2`, this.contTop2).setOrigin(0.4, 1);
    const kelp3 = ABCyaPhaser.Images.addImage(0,0, `5_Level 2/Lvl2_Kelp${this.type}_3`, this.contTop3).setOrigin(0.3, 1);
    const kelp4 = ABCyaPhaser.Images.addImage(0,0, `5_Level 2/Lvl2_Kelp${this.type}_4`, this.contTop4).setOrigin(0.6, 1);

    if (this.type === 'A') {
      this.contTop1.setPosition(0, -250);
      this.contTop2.setPosition(5, -327);
      this.contTop3.setPosition(-95, -182);
      this.contTop4.setPosition(150, this.scene.scale.height + 180);
    }
    else {
      this.contTop1.setPosition(-99, -246);
      this.contTop2.setPosition(40, -210);
      this.contTop3.setPosition(-33, -290);
      this.contTop4.setPosition(150, this.scene.scale.height + 158);
    }

    if (this.initAnim) {
      this.moveStalk(this.contTop1);
      this.moveStalk(this.contTop2);
      this.moveStalk(this.contTop3);
      this.moveStalk(this.contTop4);
    }
  }

  moveStalk (obj) {
    const randTime = Phaser.Math.Between(5000, 10000);
    const randDel = Phaser.Math.Between(0, 1000);
    let randAng;

    if (obj === this.contTop4) {
      randAng = Phaser.Math.Between(-2, 2);
    }
    else if (obj === this.contTop3) {
      randAng = Phaser.Math.Between(-3, 3);
    }
    else if (obj === this.contTop2) {
      randAng = Phaser.Math.Between(-4, 4);
    }
    else if (obj === this.contTop1) {
      randAng = Phaser.Math.Between(-5, 5);
    }

    const tween = ABCyaPhaser.Tweens.addTween(obj, randTime, { angle: randAng, delay: randDel, yoyo: true, repeat: -1, repeatDelay: randDel }, Phaser.Math.Easing.Sine.InOut);

    this.kelpTweens.push(tween);
  }

  cleanUp () {
    for (let l = 0; l < this.kelpTweens.length; l++) {
      this.kelpTweens[l].stop();
    }

    this.scene.tweens.killTweensOf(this.contTop1);
    this.scene.tweens.killTweensOf(this.contTop2);
    this.scene.tweens.killTweensOf(this.contTop3);
    this.scene.tweens.killTweensOf(this.contTop4);

    this.contTop1.destroy();
    this.contTop2.destroy();
    this.contTop3.destroy();
    this.contTop4.destroy();

    this.kelpTweens = [];
  }
}